module.exports = __webpack_public_path__ + "static/media/nextjs.5ae682e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/nextjs.png
// module id = 971
// module chunks = 0